import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import common from '../../../../common/common';
import { locale } from '../../../../utils/i18n';
import style from './style.css';
import Button from '../../button';
import api from '../../../../common/api';
import { postMessageOnParentWindow } from '../../../../common/postMessage';
import constants from '../../../../utils/constants';
import { get } from '../../../../common/cache';

class CodeIntegration extends Component {
  constructor(props) {
    super(props);
    const mid = get(constants.MID);
    const apiHost = constants.BASE_URL;
    this.state = { isJSCodeCopied: false, isCoppied: false, MID: mid, apiHost };
  }

  onTestIntigration = event => {
    event.preventDefault();
    common.log('onClick', 'Get API Keys');
    const postMessageObj = { body: { resultInfo: { resultCode: '006' } } };
    postMessageOnParentWindow(postMessageObj);
  };

  copyToClipboard = label => {
    if (this.state.isJSCodeCopied === false) {
      this.setState({ isJSCodeCopied: true });
      api
        .updateCheckoutPreference({ prefName: label, prefValue: 'Y' })
        .then(() => {
          //
        })
        .catch(() => {
          this.setState({ isJSCodeCopied: false });
        });
    }

    common.log('onClick', 'Code Copied');

    try {
      const copyText = document.getElementById('checkout-code');
      const selection = window.getSelection();
      const range = document.createRange();

      range.selectNodeContents(copyText);
      selection.removeAllRanges();
      selection.addRange(range);

      document.execCommand('copy');
      selection.removeAllRanges();

      this.updateProperties();
    } catch (e) {
      this.updateProperties();
    }
  };

  updateProperties = () => {
    if (this.state.isCoppied === false) {
      this.setState({ isCoppied: true });
      setTimeout(() => {
        this.setState({ isCoppied: false });
      }, 5000);
    }
  };

  render({}, { isCoppied, MID, apiHost }) {
    const code = `<script type="application/javascript" crossorigin="anonymous" src="${apiHost}/checkoutjs/merchants/${MID}.js" onload="onScriptLoad();"></script>
<script>
    function onScriptLoad(){
        var config = {
         "root": "",
         "flow": "DEFAULT",
         "data": {
          "orderId": "" /* update order id */,
          "token": "" /* update token value */,
          "tokenType": "TXN_TOKEN",
          "amount": "" /* update amount */
         },
         "handler": {
            "notifyMerchant": function(eventName,data){
              console.log("notifyMerchant handler function called");
              console.log("eventName => ",eventName);
              console.log("data => ",data);
            } 
          }
        };

        if(window.Paytm && window.Paytm.CheckoutJS){
            window.Paytm.CheckoutJS.onLoad(function excecuteAfterCompleteLoad() {
                // initialze configuration using init method 
                window.Paytm.CheckoutJS.init(config).then(function onSuccess() {
                   // after successfully update configuration invoke checkoutjs
                   window.Paytm.CheckoutJS.invoke();
                }).catch(function onError(error){
                    console.log("error => ",error);
                });
            });
        } 
    }
</script>
`;
    return (
      <div className={`${style['code-int']}`}>
        <h5 className={`theme-heading`}>{locale('step2.title')}</h5>
        <p className={`${style['sub-txt']}`}>{locale('step2.desc')}</p>
        <div className={`${style['code-inner']}`}>
          <div className={`${style['code-block-wrap']}`}>
            <div className={`${style['code-block']}`}>
              <input type="text" value={code} style={`display: none`} />
              <p className={`${style['code-txt']}`} id="checkout-code">
                <pre>{code}</pre>
              </p>
              <div className={`${style['code-btn-block']}`}>
                <div
                  className={`${style['copy-code']} bold`}
                  onClick={this.copyToClipboard.bind(this, 'isJSCheckoutIntegrated')}
                >
                  <img
                    className={`${style['copy-icon']}`}
                    src={`${common.getStaticPath()}/assets/images/ic-content-copy.svg`}
                    alt=""
                  />
                  {locale('step2.copy')}
                </div>
                <div className={`${style['code-copied']} ${isCoppied ? style.copied : ''} `}>Code Copied</div>
              </div>
            </div>
          </div>
          <div className={`${style['ser-int']}`}>
            <h5 className={`theme-heading`}>{locale('step2.server.integration')}</h5>
            <p className={`${style['sub-txt']}`}>
              {locale('step2.server.desc')}{' '}
              <a
                className={`primary`}
                target="_blank"
                rel="noopener noreferrer"
                href="https://developer.paytm.com/docs/blink-checkout/"
              >
                Developer Portal
              </a>
            </p>
          </div>
          <Button onButtonClick={this.onTestIntigration.bind(this)} name={locale('checkout.get.api')} />
        </div>
      </div>
    );
  }
}

export default connect(
  'isGenerateCodeStepEnabled',
  null
)(CodeIntegration);



// WEBPACK FOOTER //
// ./checkout/components/async/codeintegration/index.js